import * as Pages from '../../pages';

import { VIEW_TYPES } from '../../constants/viewTypes';
import { ROUTE_ACCESS_TYPE } from '../../constants/routeAccessType';

export const dashboardRoutes = [
    {
        path: '/dashboard',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.DashboardPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
];
